import { Component, OnInit } from '@angular/core';
import { FormGroup, Validators, FormBuilder } from '@angular/forms';
import { UniUserService } from '../../service/uniUser.service';

@Component({
  selector: 'app-experimentData',
  templateUrl: './experimentData.component.html',
  styleUrls: ['./experimentData.component.css']
})
export class ExperimentDataComponent implements OnInit {
  public registrationForm: FormGroup;
  loading = false;
  data: Object;
  constructor(
    private builder: FormBuilder,
    private uniUserService: UniUserService,
    ) { }

  ngOnInit() {
    this.registrationForm = this.builder.group({
      experiment : [ 'spq',  [ Validators.required ] ],
    });
  }
  download(){
    this.loading = true
    const value = this.registrationForm.controls.experiment.value
    console.log(value)
    console.log("holaa")
    if (value == "spq"){
      console.log("holaa")
      this.uniUserService.questions("SPQ")
      .then(resp => {
        let data1 = this.generateData(['User Id', 'Question Id', 'Word Answer'], resp.answers)
        this.exportToCsv("SPQ Experiment", data1)
        console.log(resp)
      })
    }
    else if (value === "covid") {
      this.uniUserService.questions("Covid")
      .then(resp => {
        let data1 = this.generateData(['User Id', 'Question Id', 'Word Answer'], resp.answers)
        this.exportToCsv("SPQ Experiment", data1)
        console.log(resp)
      })
    }
    else if (value === "tbw") {
      this.uniUserService.getTBW()
      .then(resp => {
        let data1 = this.generateData(['User Id', "TBM Experiment", 'Trial Number', 'Intended SOA',  "Actual SOA", "Flash TimeStamp", "Beep TimeStamp", "Response TimeStamp", "Response Flash First"], resp.answers)
        this.exportToCsv("TBW Experiment", data1)
        console.log(resp)
      })
    }
    else if (value === "memory") {
      this.uniUserService.getMemoryExperiment()
      .then(resp => {
        console.log(resp)
        let data1 = this.generateData(['Id','User Id', 'Word Order', "Encoding Block", "Word Id", "Response Choice", "Time Stamp", "Block"], resp.encoding)
        let data2 = this.generateData(["Id", "User Id", 'Word Order', "Word Id", "Response Choice", "Time Stamp", "Block"], resp.recognition)
        this.exportToCsv("Encoding Experiment", data1)
        this.exportToCsv("Recognition Experiment", data2)
      })
    }
    else if (value === "demographic") {
      this.uniUserService.questions("Demographic")
      .then(resp => {
        let data1 = this.generateData(['User Id', 'Question Id', 'Word Answer'], resp.answers)
        this.exportToCsv("Demographic Experiment", data1)
        console.log(resp)
      })
    }
    else if (value === "sensory-adaptation") {
      this.uniUserService.getSensoryAdaptation()
      .then(resp => {
        let data1 = this.generateData(['Id', 'User Id', 'Rating Number', 'Rate Loudness'], resp.answers)
        this.exportToCsv("Sensory Adaptation Experiment", data1)
        console.log(resp)
      })
    }
    else if (value === "oddBall") {
      this.uniUserService.oddBall()
      .then(resp => { 
        console.log(resp)
        let data1 = this.generateData(['Id', 'User Id', 'Stimulus Order', 'Block', 'Side', 'Stimulus', 'Stimulus TimeStamp', 'Response TimeStamp', 'Responded Target'], resp.oddBall)
        this.exportToCsv("Odd Ball Experiment", data1)
      })
    }
    this.loading = false
  }
  generateData(firstRow, data){
    var finalData = [firstRow]
    for (var i = 0; i < data.length; i++) {   
      let auxList = []    
      for (const [key, value] of Object.entries(data[i])) 
      {
        auxList.push(value)
      }
      finalData.push(auxList)
    }
    return finalData

  }
  exportToCsv(filename, rows) {
    var processRow = function (row) {
        var finalVal = '';
        for (var j = 0; j < row.length; j++) {
            var innerValue = row[j] === null ? '' : row[j].toString();
            if (row[j] instanceof Date) {
                innerValue = row[j].toLocaleString();
            };
            var result = innerValue.replace(/"/g, '""');
            if (result.search(/("|,|\n)/g) >= 0)
                result = '"' + result + '"';
            if (j > 0)
                finalVal += ',';
            finalVal += result;
        }
        return finalVal + '\n';
    };

    var csvFile = '';
    for (var i = 0; i < rows.length; i++) {
        csvFile += processRow(rows[i]);
    }

    var blob = new Blob([csvFile], { type: 'text/csv;charset=utf-8;' });
    if (navigator.msSaveBlob) { // IE 10+
        navigator.msSaveBlob(blob, filename);
    } else {
        var link = document.createElement("a");
        if (link.download !== undefined) { // feature detection
            // Browsers that support HTML5 download attribute
            var url = URL.createObjectURL(blob);
            link.setAttribute("href", url);
            link.setAttribute("download", filename);
            link.style.visibility = 'hidden';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        }
    }
}

  unitChanged(){
    console.log("HOLAAA")
  }

}
